import { useTranslation } from 'react-i18next';
import { DASHBOARD_ACTIVITY_PER_PAGE } from 'infrastructure/hooks/rpm';
import { memo, type FC } from 'react';
import BasePagination from 'components/atoms/base-pagination';
import { ELASTIC_SEARCH_MAX_ITEMS } from 'constants/count';
import { safeClamp } from 'utils/helpers/safeClamp';
import RpmOverviewTable from 'components/molecules/rpm-overview-table';
import {
  useOverviewDashboardFilter,
  useRpmOverviewDashboard,
} from 'infrastructure/hooks/rpm/overview-dashboard';
import SortSelectBox from 'components/molecules/rpm-overview-table/components/sort-select-box';
import useUser from 'utils/useUser';
import BoardTypeToggle from 'pages/rpm/overviewDashboard/board-type-toggle';

import s from './styles.module.scss';

const RpmOverviewDashboard: FC = () => {
  const { t } = useTranslation();
  const { filter, updateFilter } = useOverviewDashboardFilter();
  const { patients, isLoading } = useRpmOverviewDashboard(filter);
  const { isMedicalAssistantRole, hasRNRole, isAgencyDoctor } = useUser();

  const hideSortSelect =
    isAgencyDoctor && (isMedicalAssistantRole || hasRNRole);

  const wrapperId = 'rpm-overview-dashboard';

  return (
    <div className={s.wrapper} id={wrapperId}>
      <div className={s.header}>
        <div className={s.left}>
          <p className={s.readings}>
            {t('labels.patients')}: <span>{patients?.count ?? 0}</span>
          </p>
          <BoardTypeToggle />
        </div>
        {!hideSortSelect && (
          <SortSelectBox
            value={filter.sorting}
            onChange={(v) => updateFilter({ sorting: v, page: undefined })}
            allowClear
            withNone={false}
          />
        )}
        <div>
          <BasePagination
            page={filter.page}
            total={safeClamp(patients?.count, 0, ELASTIC_SEARCH_MAX_ITEMS)}
            align="end"
            onChange={(newPage) => {
              updateFilter({ page: newPage });
            }}
            pageSize={DASHBOARD_ACTIVITY_PER_PAGE}
            pageSizeOptions={[]}
            hide={false}
            showSizeChanger={false}
          />
        </div>
      </div>
      <div className={s.divider} />
      <div className={s.body}>
        <RpmOverviewTable
          patients={patients?.data}
          loading={isLoading}
          page={1}
          setPage={() => {}}
          pageSize={DASHBOARD_ACTIVITY_PER_PAGE}
          wrapperId={wrapperId}
        />
      </div>
    </div>
  );
};
export default memo(RpmOverviewDashboard);
